module.exports = __webpack_public_path__ + "static/media/registirane_na_narushenie.87c0af98.pdf";